<template>
  <div class="row page-wrapper">
    <div class="col-12">
      <div class="row justify-content-center page-header">
        <div class="col-12 col-xl-10">
          <h3>Bearbeiten Lizenz</h3>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12 col-xl-10">
          <div class="row form-wrapper justify-content-center">
            <div class="col-12">
              <b-form
                class="new-entity-form"
                @submit="onSubmit"
              >
                <div class="row">
                  <div class="col-12 col-lg-6">
                    <b-form-group label="Version">
                      <b-form-input
                        v-model="formData.version"
                        :type="'number'"
                        :max="maxVersion"
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-lg-6">
                    <b-form-group label="Geräteanzahl">
                      <b-form-input
                        v-model="formData.numberOfDevices"
                        :type="'number'"
                        :min="1"
                      />
                    </b-form-group>
                  </div>
                  <div class="col-12 col-lg-6">
                    <b-form-group label="Gültig bis">
                      <datepicker
                        v-model="formData.validUntil"
                        :language="datepickerSettings.de"
                        :disabled-dates="datepickerSettings.disabledDates"
                        :format="'dd/MM/yyyy'"
                        :input-class="'datepicker bg-white'"
                        :bootstrap-styling="true"
                        :clear-button="true"
                        :monday-first="true"
                        type="date"
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-lg-6">
                    <b-form-group label="iPod">
                      <b-form-input
                        v-model="formData.iPodCount"
                        :type="'number'"
                        :min="0"
                      />
                    </b-form-group>
                  </div>
                  <div class="col-12 col-lg-6">
                    <b-form-group label="iPad">
                      <b-form-input
                        v-model="formData.iPadCount"
                        :type="'number'"
                        :min="0"
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <b-form-group label="Modules">
                      <b-form-checkbox-group
                        v-model="formData.modules"
                        :options="licenseModuleOptions"
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="row justify-content-end">
                  <div class="col-12">
                    <b-form-group class="form-button-group">
                      <b-button
                        variant="outline-primary"
                        class="btn-cancel"
                        @click="goBack"
                      >
                        Zurück
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary"
                        :disabled="!isFormValid"
                      >
                        Bearbeiten
                      </b-button>
                    </b-form-group>
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {de} from 'vuejs-datepicker/dist/locale';
import Datepicker from 'vuejs-datepicker';
import {NavigationMixin, LicenseMixin, CompanyMixin, AuthMixin} from '../../mixins';
import appConfig from '../../app.config';
import {LICENSE_MODULES, ROLE_AVAILABLE_LICENSE_MODULES} from '../../constants';
import {BFormCheckboxGroup} from 'bootstrap-vue';
import {mapState, mapActions} from 'vuex';

export default {
  name: 'AddLicense',
  components: {
    Datepicker,
    BFormCheckboxGroup
  },
  mixins: [NavigationMixin, LicenseMixin, CompanyMixin, AuthMixin],
  data: function () {
    return {
      formData: {
        numberOfDevices: null,
        iPodCount: 0,
        iPadCount: 0,
        validUntil: null,
        version: appConfig.defaultLicenseVersion,
        modules: []
      },
      companies: [],
      selectedCompany: null,
      datepickerSettings: {
        de,
        disabledDates: {
          to: new Date()
        }
      },
      maxVersion: appConfig.defaultLicenseVersion,
      licenseModuleOptions: []
    };
  },
  computed: {
    isFormValid() {
      return this.formData.numberOfDevices && this.formData.validUntil && this.formData.version !== null;
    },
    ...mapState({
      selectedLicense: state => state.license.selectedLicense
    })
  },
  created() {
    this.licenseModuleOptions = Object.values(LICENSE_MODULES).filter(m => ROLE_AVAILABLE_LICENSE_MODULES[this.auth.role].includes(m));

    if (this.selectedLicense) {
      Object.keys(this.formData).forEach(key => this.formData[key] = this.selectedLicense[key]);
    } else {
      this.loadLicense();
    }
  },
  methods: {
    ...mapActions({
      setSelectedLicense: 'license/setSelectedLicense'
    }),
    async loadLicense() {
      try {
        const response = await this.licenseService.getLicenseById(this.$route.params.id);
        Object.keys(this.formData).forEach(key => this.formData[key] = response.license[key]);
        console.log(this.formData);
      } catch (err) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Bearbeiten Lizenz',
          text: (err && err.error) ? err.error.message : 'Failed to retrieve the license.'
        });
      }
    },
    async onSubmit(evt) {
      evt.preventDefault();
      if (this.isFormValid) {
        try {
          const payload = {...this.formData};
          const validUntil = moment.utc(payload.validUntil);
          validUntil.set('hour', 0);
          validUntil.set('minute', 0);
          validUntil.set('second', 0);
          validUntil.set('millisecond', 0);
          payload.validUntil = validUntil.toISOString();
          await this.licenseService.updateLicense(this.$route.params.id, payload);
          this.goToPath('/licenses');
        } catch (err) {
          this.$notify({
            group: 'app',
            type: 'error',
            title: 'Bearbeiten Lizenz',
            text: (err && err.error) ? err.error.message : 'Failed to update the license.'
          });
        }
      }
    },
    setSelectedCompany(company) {
      this.selectedCompany = company;
      this.formData.companyId = company.id;
    }
  }
};
</script>
